import { useTranslation } from 'react-i18next';
import { IconSelect } from '@/core/IconSelect.molecule';
import type { ReactSelectOption } from '@/core/IconSelect.molecule';

interface ColumnDropdownProps {
  testId: string;
  dropdownOptions: { value: string; text: string; description?: string }[];
  selectOption: (value?: string, oldValue?: string) => void;
  label: string;
  currentDropdownValue?: string;
  creatable?: boolean;
  isSearchable?: boolean;
  isClearable?: boolean;
  optionsHaveDescriptions?: boolean;
  showError?: boolean;
  isLabelBold?: boolean;
  textEntryAllowed?: boolean;
  disabled?: boolean;
  textInputPlaceholder?: string;
  inputToggleTooltip?: string;
}
export const ColumnDropdown = ({
  testId,
  dropdownOptions,
  label,
  currentDropdownValue,
  selectOption,
  creatable = false,
  isSearchable = false,
  isClearable = true,
  optionsHaveDescriptions = false,
  showError,
  isLabelBold = true,
  textEntryAllowed = false,
  disabled = false,
  textInputPlaceholder,
  inputToggleTooltip,
}: ColumnDropdownProps) => {
  const { t } = useTranslation();

  const selectOptions = optionsHaveDescriptions
    ? dropdownOptions.map((option) => ({
        ...option,
        label: (
          <>
            <div data-testid="optionText">
              <strong>{t(option.text)}</strong>
            </div>
            {option.description && <small>{t(option.description)}</small>}
          </>
        ),
      }))
    : dropdownOptions;

  return (
    <>
      {label && (
        <div className="flexColumnContainer flexAlignCenter">
          <div
            className={`tw:mb-0 tw:py-1.5 mr5 mt3 ${isLabelBold ? 'text-bold' : ''}`}
            data-testid={`${testId}-label`}>
            {t(label)}
          </div>
        </div>
      )}

      <IconSelect
        testId={testId}
        selectOptions={selectOptions}
        formattedOptions={optionsHaveDescriptions}
        value={currentDropdownValue}
        onChange={(params: ReactSelectOption | undefined) => {
          const selectedValue = params ? (params.value as string) : undefined;
          selectOption(selectedValue, currentDropdownValue);
        }}
        creatable={creatable}
        isSearchable={isSearchable}
        placeholder={t('SCALING.COLUMN_INPUT_PLACEHOLDER')}
        showError={showError}
        isClearable={isClearable}
        textEntryAllowed={textEntryAllowed}
        textToggleDisabled={!textEntryAllowed}
        disabled={disabled}
        textInputPlaceholder={textInputPlaceholder}
        inputToggleTooltip={inputToggleTooltip}
      />
    </>
  );
};
